export default "__VITE_ASSET__BnXActiQ__"